<template>
    <div class="test">
        <selectorPedidos />
       <!-- <el-row :gutter="20">
           <el-col :sm="24" :offset="0" >
              
              <el-table :data="casos" border stripe fit style="width:100%;    overflow-x: hidden;"  >
                  <el-table-column
      type="index"
      width="50">
    </el-table-column>
                  <el-table-column label="Caso" prop="obs"  >
                  </el-table-column>
                    <el-table-column label="Vtex" prop="vtex_id" width="170" >
                  </el-table-column>
                   <el-table-column label="" width="150" >
                       <template slot-scope="scope">
                           
                           <el-button type="success" size="mini" @click="verCaso(scope.row.vtex_id)">ver</el-button>
                           <el-button type="danger" size="mini" :loading="reinciando == scope.row.vtex_id" icon="el-icon-delete" @click="resetCaso(scope.row.vtex_id)"></el-button>
                           
                        
                       </template>
                  </el-table-column>
              </el-table>
              
               
               
           </el-col>
          
       </el-row> -->
       
    </div>
</template>

<script>
import {HTTP} from "@/axios"
import selectorPedidos from "@/components/selectorPedidos"
    export default {
        components: {
            selectorPedidos
        },
        data() {
            return {
                casos: [],
                reinciando:false
            }
        },
        created() {
            this.getCasosTest()
        },
        methods: {
            resetCaso(pedido)
            {
                this.reinciando = pedido
			HTTP.post('https://caba33.suizoargentina.com.ar/sellerpostventaold/reiniciarPedido', {
				pedido: pedido
			}).then((res) => {
				console.log(res)
				this.reinciando = false
				
			})
            },
            verCaso(pedido)
            {
                let routeData = this.$router.resolve({name: 'reclamo', params: {pedido}})
                window.open(routeData.href, '_blank');        

            },
            getCasosTest() {
                HTTP.get('/getCasosTest')
                   .then(res => {
                       this.casos = res.data
                   })
            }
        },
    }
</script>

<style lang="scss" scoped>
.test
{
    max-width: 1170px;
    margin:30px auto;
    min-height:100vh;
   
}
</style>